<template>
  <div>
    <CModal :show.sync="activeDelete" centered :draggable="false">
      <template slot="header-wrapper">
        <div/>
      </template>
      Etes-vous sûr de vouloir supprimer {{ activeDeleteName }} ?
      <template slot="footer">
        <CButton color="secondary" class="mr-2" @click="activeDelete = null">
          Non
        </CButton>
        <CButton
          color="primary"
          @click="deleteEcole"
          data-cy="confirm-delete-button"
        >
          Oui
        </CButton>
      </template>
    </CModal>
    <ReferenceTableActions
      table-name="école"
      :buttons="['create', 'template', 'upload', 'export']"
      @create="showCreate"
      @template="downloadFile({
                fileName: 'ecoles_template.xlsx',
                downloadURL: ECOLE_ENDPOINTS.template,
             })"
      @upload="uploadEcoles"
      @export="downloadFile({
          downloadURL: ECOLE_ENDPOINTS.export,
          query: $refs.ecoleTable.tableQuery
        })"
    />
    <table-component
      :columns="tableColumns"
      :url="ECOLE_ENDPOINTS.base"
      :pagination-text-position="'bottom'"
      :init-filters="filters"
      ref="ecoleTable"
    >
      <template slot="actions" slot-scope="{ row }">
        <div class="d-flex flex-wrap" style="row-gap: 0.25em; column-gap: 0.5em">
          <CButton
            class="sm outline action-button"
            color="primary"
            size="sm"
            variant="outline"
            @click="showEdit(row)"
          >
            <em class="fa fa-edit"/>
            Modifier
          </CButton>
          <CButton
            class="action-button"
            color="danger"
            size="sm"
            @click="activeDelete = row; activeDeleteName = row.email"
            data-cy="delete-button"
          >
            <em class="fa fa-close"/>
            Supprimer
          </CButton>
        </div>
      </template>
    </table-component>
    <CModal
      :show.sync="showModal"
      :draggable="false"
      :resizable="false"
      centered
    >
      <template slot="header">
        {{ isEdit ? "Modification d'une école" : "Création d'une nouvelle école" }}
      </template>
      <div class="d-flex flex-column gap-2">
        <div class="bg-extended-color44 p-2" v-if="alertMessage">
          {{ alertMessage }}
        </div>
        <CInput
          class="danger"
          required
          label="Ecole"
          :disabled="isEdit"
          v-model="newEcole.name"
        />
        <CInput
          label="Email"
          required
          v-model="newEcole.email"
        />
      </div>
      <template slot="footer">
        <div>
          <CButton
            color="secondary"
            class="mr-2"
            @click="showModal=false; oldEcoleName = null"
          >
            Annuler
          </CButton>
          <CButton
            color="primary"
            :disabled="!!alertMessage"
            @click="isEdit ? updateEcole() : createEcole()"
          >
            {{ isEdit ? "Sauvegarder" : "Créer une école" }}
          </CButton>
        </div>
      </template>
    </CModal>
  </div>
</template>

<script>
import ReferenceTableActions from "@/components/ReferenceTableActions";
import {ECOLE_ENDPOINTS, EcoleService} from "@/services/ecole";
import {downloadFile} from "@/utils/request";
import {FilesService} from "@/services/files";

export default {
  name: "Ecoles",
  components: {
    ReferenceTableActions
  },
  watch: {
    newEcole: {
      handler() {
        this.alertMessage = ""
      },
      deep: true,
    }
  },
  data() {
    return {
      activeDeleteName: null,
      alertMessage: "",
      isUploading: false,
      ECOLE_ENDPOINTS,
      tableColumns: [
        "name",
        "email",
        "actions",
      ],
      showModal: false,
      clearEcole: {
        name: "",
        email: "",
      },
      filters: {},
      newEcole: {},
      activeDelete: null,
      isEdit: null,
      oldEcoleName: null,
    }
  },
  mounted() {
    this.newEcole = this.clearEcole;
  },
  computed: {
    mandatoryFilled() {
      return !!this.newEcole.name?.replace(/ /g, "") &&
        !!this.newEcole.email?.replace(/ /g, "")
    }
  },
  methods: {
    downloadFile,
    async refreshTableData() {
      await this.$refs.ecoleTable.$refs.table.getData()
    },
    async createEcole() {
      this.saveFilters();
      await this.checkIfInputCorrect()
      if (!!this.alertMessage) return
      const {res} = await EcoleService.createEcole({
        name: this.newEcole.name,
        email: this.newEcole.email,
      });
      if (res.status !== 201) alert("Something went wrong")
      else {
        this.showModal = false;
        await this.refreshTableData()
      }
      this.newEcole = this.clearEcole;
    },
    async uploadEcoles(files) {
      this.isUploading = true;
      await FilesService.uploadFile({
        file: files[0],
        url: ECOLE_ENDPOINTS.base  + "upload/",
        onError: (res) => {
          alert(res.detail);
          this.isUploading = false;
        },
        onSuccess: (res) => {
          alert(res.message);
        }
      });
      this.isUploading = false;
      await this.refreshTableData()
    },
    async checkIfInputCorrect() {
      const {data, res} = await EcoleService.checkEcole(this.newEcole.name);
      if (
        data &&
        !(this.oldEcoleName.toLowerCase() === this.newEcole.name.toLowerCase()) &&
        res.status === 200
      ) this.alertMessage = "école with provided code already exists!";
      else if (!this.mandatoryFilled) this.alertMessage = 'Required fields are missing!'
      else if(!this.newEcole.email.match(/\S+@\S+\.\S+/)) this.alertMessage = 'Wrong format email'
      else this.alertMessage = ""
    },
    saveFilters() {
      this.filters = {};
      Object.entries(this.$refs.ecoleTable.tableQuery).forEach((filter) => {
        if (!["byColumn", "order_by", "page", "per_page"].includes(filter[0])) {
          this.filters[filter[0]] = filter[1];
        }
      });
    },
    async updateEcole() {
      this.saveFilters();
      await this.checkIfInputCorrect()
      if (!!this.alertMessage) return
      const {res} = await EcoleService.updateEcole(this.isEdit, {
        name: this.newEcole.name,
        email: this.newEcole.email,
      });
      if (res.status !== 200) alert("Something went wrong");
      this.isEdit = null;
      this.newEcole = this.clearEcole;
      this.showModal = false;
      this.oldEcoleName = null
      await this.refreshTableData()
    },
    async deleteEcole() {
      this.saveFilters();
      const {res} = await EcoleService.deleteEcole(this.activeDelete._id);
      if (res.status !== 200) alert("Something went wrong");
      this.activeDelete = null;
      await this.refreshTableData()
    },
    showCreate() {
      this.isEdit = false;
      this.newEcole = {};
      this.showModal = true;
    },
    showEdit(ecole) {
      this.oldEcoleName = ecole.name;
      this.isEdit = ecole._id;
      this.newEcole = {...ecole};
      this.showModal = true;
    },
  }
}
</script>
